import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// import * as apiConfig from '../config/api.config';
import { ApiConfig } from '../config/api.config';

@Injectable()
export class XsaConstsService {
    authHttp:any={};
    constructor(protected http: HttpClient,private apiConfig:ApiConfig) {
        // this.authHttp=new AuthHttp(new AuthConfig, http);
    }

    getXsaItems(tag: string): Observable<any> {
        const query = `item=${tag}`;
        return this.http
            .get(`${this.apiConfig.API_HOST}/api/xsaConsts/?${query}`)
            .pipe(
				map((response: Response) => {
					return response;
				})
			);
    }
}
